function PageButtons(params) {
    const { totalPages, currentPage, onButtonClicked } = params;

    const buttonsElements = GenerateButtons(totalPages, currentPage).map((b) => (
        <button
            key={b.index}
            onClick={(e) => {
                e.preventDefault();
                onButtonClicked(b.index);
            }}
            style={{
                margin: '0 4px',
                padding: '8px 14px',
                borderRadius: '8px',
                border: b.selected ? 'none' : '1px solid #d1d5db',
                backgroundColor: b.selected ? '#4f46e5' : '#fff',
                color: b.selected ? '#fff' : '#374151',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
            }}
            onMouseOver={(e) => !b.selected && (e.target.style.backgroundColor = '#f3f4f6')}
            onMouseOut={(e) => !b.selected && (e.target.style.backgroundColor = '#fff')}
        >
            {b.name.replace(/-/g, '')}
        </button>
    ));

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px 0' }}>
            {buttonsElements}
        </div>
    );
}

function GenerateButtons(totalPages, currentPage) {
    const ButtonCount = 5;
    const ButtonCenter = 3;
    const buttons = [];

    if (totalPages <= ButtonCount) {
        for (let i = 1; i <= totalPages; i++)
            buttons.push({name: i === currentPage ? `-${i}-` : `${i}`, index: i, selected: i === currentPage});

        return buttons;
    }

    if (currentPage <= ButtonCenter) {
        for (let i = 1; i <= ButtonCenter; i++)
            buttons.push({name: i === currentPage ? `-${i}-` : `${i}`, index: i, selected: i === currentPage});

        buttons.push({name: `${ButtonCenter + 1}>`, index: ButtonCenter + 1, selected: false});
        buttons.push({name: `${totalPages}>>`, index: totalPages, selected: false});
        return buttons;
    }

    if (currentPage >= totalPages - ButtonCenter + 1) {
        buttons.push({name: `<<${1}`, index: 1, selected: false});
        buttons.push({name: `<${totalPages - ButtonCenter}`, index: totalPages - ButtonCenter, selected: false});
        for (let i = totalPages - ButtonCenter + 1; i <= totalPages; i++)
            buttons.push({name: i === currentPage ? `-${i}-` : `${i}`, index: i, selected: i === currentPage});

        return buttons;
    }

    buttons.push({name: `<<${1}`, index: 1, selected: false});
    buttons.push({name: `<${currentPage - 1}`, index: currentPage - 1, selected: false});
    buttons.push({name: `-${currentPage}-`, index: currentPage, selected: true});
    buttons.push({name: `${currentPage + 1}>`, index: currentPage + 1, selected: false});
    buttons.push({name: `${totalPages}>>`, index: totalPages, selected: false});

    return buttons;
}

export default PageButtons;